import { DeleteAccountDialog } from '@/features/users/components/dialogs';
import { getMessage } from '@/shared/copy/messages';
import { Panel, Stack, Text } from '@/ui';
import { Button } from '@/ui/primitives';
import type { DeleteAccountPanelState } from '@/features/users/hooks/useDeleteAccountPanel';
import type { ReactElement } from 'react';

type DeleteAccountPanelProps = { deleteAccount: DeleteAccountPanelState };

export const DeleteAccountPanel = ({ deleteAccount }: DeleteAccountPanelProps): ReactElement => {
  return (
    <>
      <Panel title={getMessage('account.delete.panelTitle')}>
        <Stack gap="md">
          <Stack direction={{ xs: 'column', sm: 'row' }} gap="sm" align={{ sm: 'center' }}>
            <Text role="body" color="textSecondary" sx={{ flex: 1 }}>
              {getMessage('account.delete.panelDescription')}
            </Text>
            <Button
              variant="destructive"
              fullWidthOnMobile={false}
              disabled={deleteAccount.deleteDisabled}
              onClick={deleteAccount.onOpen}
            >
              {getMessage('account.delete.panelCta')}
            </Button>
          </Stack>
        </Stack>
      </Panel>
      <DeleteAccountDialog
        open={deleteAccount.deleteOpen}
        password={deleteAccount.deletePassword}
        passwordErrorMessage={deleteAccount.deletePasswordError ?? undefined}
        loading={deleteAccount.isDeleting}
        confirmDisabled={deleteAccount.confirmDisabled}
        onPasswordChange={deleteAccount.onPasswordChange}
        onClose={deleteAccount.onClose}
        onConfirm={deleteAccount.onConfirm}
      />
    </>
  );
};
